import React, { Component } from "react";
import Product from "./product";

export default class Products extends Component {
  render() {
    const { products } = this.props;

    if (products.length === 0) return <span>Načítám produkty...</span>;

    return (
      <div className="products">
        <h3>Nejlépe hodnocené</h3>
        <ul className="product-list cleaner">
          {products.map((product) => (
            <Product product={product} />
          ))}
        </ul>
      </div>
    );
  }
}
